const CHeaderTopNavMenuSubmenuFragments = {
  field: `
  fragment submenuFragment on submenu_BlockType {
    linkTitle
    linkUrl
    linkOrder
    openNewTab
  }
  `,
}

export const CHeaderTopNavMenuFragments = {
  field: `
    fragment headerTopNavMenu on headerTopNavMenu_MatrixField {
      ... on headerTopNavMenu_item_BlockType {
        linkTitle
        linkUrl
        linkOrder
        openNewTab
        submenu {
          ...submenuFragment
        }
      }
    }
    ${CHeaderTopNavMenuSubmenuFragments.field}
  `,
}
